import {
  BASE_LOAN_URL,
  LOAN_TAX_BY_INSTALLMENTS,
  type PossibleMonthlyInstallments,
} from '../constants'

const baseTax = (totalLoan: number) =>
  totalLoan + (totalLoan * 0.38) / 100 + (0.008 * 30 * totalLoan) / 100

const monthlyTax = (installments: PossibleMonthlyInstallments) => {
  const tax = LOAN_TAX_BY_INSTALLMENTS[installments]

  return (tax * (1 + tax) ** installments) / ((1 + tax) ** installments - 1)
}

const calculateInstallmentsValue = (
  totalLoan: number,
  installments: PossibleMonthlyInstallments,
) => {
  const finalTax = monthlyTax(installments) * baseTax(totalLoan)

  return parseFloat(finalTax.toFixed(2))
}

function createUrlToRequestLoanFrom(moneyAmount: number, installments: number) {
  return `${BASE_LOAN_URL}%3Fs_desired_value%3D${moneyAmount}%26s_installment%3D${installments}%26utm_source%3Demprestimo`
}

type RangeProps = Record<'value' | 'min' | 'max', number | string>

const getPercentByRange = ({ value, min, max }: RangeProps) =>
  ((Number(value) - Number(min)) / (Number(max) - Number(min))) * 100

export { calculateInstallmentsValue, createUrlToRequestLoanFrom, getPercentByRange }
